// extracted by mini-css-extract-plugin
module.exports = {"contentXarxes":"social_contentXarxes__LGMGO","xarxesHeader":"social_xarxesHeader__X22Fw","social":"social_social__v0fuA","iconaSocial":"social_iconaSocial__eVcJw"};